<template>
    <div class="options row m-0">
        <label class="col-12 col-xl-3 p-0 mr-xl-3 mb-2" v-if="$parent.type != 'searchbox-hotel'">
            <div class="heading mb-1">Departure {{ $parent.isCruiseport ? 'Cruise Port' : 'Airport' }}</div>
            <algolia-typeahead
                id="searchbox-airport"
                name="searchbox-airport"
                ref="algoliaTypeahead"
                :airport="query.airport"
                :placeholder="$parent.isCruiseport ? 'Enter departure cruise port' : 'Enter departure airport'">
            </algolia-typeahead>
        </label>

        <div class="col p-0 row m-0 mb-2 dates" :class="{ 'dates--with-times': addEntryExitTimes }">
            <label class="p-0 pr-sm-3 date_input" :class="addEntryExitTimes ? 'col-sm-3' : 'col-sm-6'">
                <div class="heading mb-1">{{ getFieldTitle(getPackageType(), 0) }}</div>
				<span class="date-text" :class="{ 'date-text--placeholder': !query.date1 }">{{ query.date1 ? $parent.formatDate(query.date1) : 'Select Date' }}</span>
                <input type="text" @blur="dateChanged('checkin')" name="checkindate" v-model="query.date1" data-field="date1" placeholder="Select Date"
                       data-parsley-required-message="Please select a date." data-toggle="tooltip" :data-original-title="getFieldTooltip(getPackageType(), 0)" readonly required>
                <i class="apr-icon-calendar input-icon mr-3"></i>
            </label>
            <label v-if="addEntryExitTimes" class="col-sm-3 p-0 pr-sm-3 date_input time_input">
                <div class="heading mb-1">Check-In Time</div>
                <select class="form-control time-select" name="checkintime" :value="query.checkintime" @change="$parent.setTimes($event.target.value, query.checkouttime)">
                    <option v-for="(time, value) in $parent.parkingTimes" :value="value">{{ time }}</option>
                </select>
                <i class="apr-icon-time input-icon mr-3"></i>
            </label>
            <label class="p-0 date_input" :class="addEntryExitTimes ? 'col-sm-3 pr-sm-3' : 'col-sm-6 pl-sm-0'">
                <div class="heading mb-1">{{ getFieldTitle(getPackageType(), 1) }}</div>
				<span class="date-text" :class="{ 'date-text--placeholder': !query.date2 }">{{ query.date2 ? $parent.formatDate(query.date2) : 'Select Date' }}</span>
                <input type="text" @blur="dateChanged('checkout')" name="checkoutdate" v-model="query.date2" data-field="date2" placeholder="Select Date"
                       data-parsley-required-message="Please select a date." data-toggle="tooltip" :data-original-title="getFieldTooltip(getPackageType(), 1)" readonly required>
                <i class="apr-icon-calendar input-icon"></i>
            </label>
            <label v-if="addEntryExitTimes" class="col-sm-3 p-0 pl-sm-0 date_input time_input">
                <div class="heading mb-1">Check-Out Time</div>
                <select class="form-control time-select" name="checkouttime" :value="query.checkouttime" @change="$parent.setTimes(query.checkintime, $event.target.value)">
                    <option v-for="(time, value) in $parent.parkingTimes" :value="value" :disabled="$parent.isCheckoutTimeDisabled(value)">{{ time }}</option>
                </select>
                <i class="apr-icon-time input-icon"></i>
            </label>
        </div>

        <div class="col-12 col-xl-2 p-0 pl-xl-3 my-3 my-xl-0">
            <div class="d-none d-xl-block heading mb-1 invisible">Submit</div>
            <button type="submit" class="btn-brand-primary" :style="{'min-width': $parent.type != 'searchbox-inline' ? '100px' : '180px' }">
                <span v-if="!$parent.inProgressSearch && $parent.type === 'searchbox'">SEARCH</span>
                <span v-if="!$parent.inProgressSearch && $parent.type === 'searchbox-inline'" style="white-space: nowrap">UPDATE SEARCH</span>
                <span v-if="!$parent.inProgressSearch && $parent.type === 'searchbox-hotel'" style="white-space: nowrap">UPDATE</span>
                <i v-if="!$parent.inProgressSearch" class="apr-arrow-right" aria-hidden="true"></i>
                <span v-if="$parent.inProgressSearch" class="btn-brand-primary__loading-container" aria-hidden="true">
                  <span class="btn-brand-primary__loading"></span>
                </span>
            </button>
            <span class="cancel" v-if="$parent.isEditMode" :style="{'min-width': $parent.type != 'searchbox-inline' ? '100px' : '180px' }">
                <a href="#" @click.prevent="$parent.isEditMode = false; $parent.setTab($parent.sessionTab);">Cancel</a>
            </span>
        </div>
    </div>
</template>

<script>
    import AlgoliaTypeahead from '../components/AlgoliaTypeahead'
    import Datepicker from './../../datepicker'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        mixins: [Datepicker],
        components: {AlgoliaTypeahead},

        mounted() {
            if (this.isTouchDevice() === false) {
                $('[data-toggle="tooltip"]').tooltip();
            }

            if (this.addEntryExitTimesReady) {
                this.initDatepickers()
            }
        },

        computed: {
            ...mapGetters([
                'session', 'query',
            ]),

            addEntryExitTimes() {
                return this.$parent.addEntryExitTimes
            },

            addEntryExitTimesReady() {
                return this.$parent.addEntryExitTimesReady
            },
        },

        watch: {
            addEntryExitTimesReady(ready) {
                if (ready) {
                    this.initDatepickers()
                }
            },
        },

        methods: {
            initDatepickers() {
                let $form = $(this.$el)

                if (!this.addEntryExitTimes) {
                    this.$parent.initSearchboxDatepickers($form, {productType: 'apr'})
                    return
                }

                this.initDatepicker($form.find("input[name='checkindate']"), {productType: 'apr'})
                this.initDatepicker($form.find("input[name='checkoutdate']"), {productType: 'apr'})
            },

            setDate(date, fieldName) {
                this.$parent.setDates(
                    fieldName === 'checkindate' ? date : this.query.date1,
                    fieldName === 'checkoutdate' ? date : this.query.date2
                )
            },

            isTouchDevice(){
                return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
            },

            getFieldTitle(_package, _index) {
                if (! _package) { _package = 'PSF' }
                return this.$parent.titles[_package].dates[_index]
            },

            getFieldTooltip(_package, _index) {
                if (! _package) { _package = 'PSF' }
                return this.$parent.titles[_package].tooltips[_index]
            },

            getPackageType() {
                if (this.currentTab == 'hotel') { return 'PSF' }
                if (this.currentTab == 'shuttle') { return 'SF' }
                return 'APR'
            },

            dateChanged(when) {
                if (when == 'checkin') {
                    this.triggerSearchboxEvent(apr.event_category,`Check-in date entered ${this.$parent.currentTab}`, '')
                } else {
                    this.triggerSearchboxEvent(apr.event_category,`Check-out date entered ${this.$parent.currentTab}`, '')
                }
            },

            triggerSearchboxEvent(action, label = '') {
                dataLayer.push({
                    'event': 'GaEvent',
                    'EventCategory': apr.event_category,
                    'EventAction': action,
                    'EventLabel': label
                });
            },
        }
    };
</script>
